import { FC, PropsWithChildren } from "react";
import classNames from "classnames/bind";

import { ToastProps } from "./Toast.types";
import styles from "./Toast.module.scss";

const cx = classNames.bind(styles);

export const Toast: FC<PropsWithChildren<ToastProps>> = ({
    className,
    children,
}) => {
    return <div className={cx("root", className)}>{children}</div>;
};
